import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { SubmitButton } from 'components/form/prototypes';

const Back = ({ isReturn }) => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const { id } = useParams();

  const [visible, setVisible] = useState(false);

  // Hacky ordered(!) list of IDs belonging to NCR status cycle.
  const ncrStatusIds = [
    1, // Draft
    2, // Pending Approval
    3, // Approved
    4, // Order Pending
    5, // Pending CAR
    9, // CAR Completed
    6, // Closed
    7, // Cancelled
  ];

  // Hacky ordered(!) list of IDs belonging to NCR status cycle.
  const returnStatusIds = [
    1, // Draft
    2, // Pending Approval
    3, // Approved
    8, // Return Pending
    6, // Closed
    7, // Cancelled
  ];

  useEffect(() => {
    setVisible((_) => user.role === 'GM' && state.ncr.status.id > 1);
  }, [user.role, state.ncr.status.id]);

  // Get index of current status from relevant array
  // (different arrays for NCR vs. Return statuses)
  const currentStatusIndex = isReturn
    ? returnStatusIds.findIndex((s) => s === state.ncr.status.id)
    : ncrStatusIds.findIndex((s) => s === state.ncr.status.id);

  // If current status is 7 (cancelled), then jump to status 2 (pending approval)
  // Otherwise, lookup new status ID by decrementing index value
  // on relevant array.
  const newStatusId =
    state.ncr.status.id === 7
      ? 2
      : isReturn
      ? returnStatusIds[currentStatusIndex - 1]
      : ncrStatusIds[currentStatusIndex - 1];

  const request = {
    method: 'patch',
    url: `/api/ncr/${id}`,
    data: {
      ...state.ncr,
      status: { id: newStatusId },
      amended_by: user.id,
    },
  };

  return (
    visible && (
      <>
        <SubmitButton
          name="Go Back"
          request={request}
          validate
          toast={{ message: 'Going back a stage' }}
        />
      </>
    )
  );
};

export { Back };
